import { ApiClientInstance } from '@shared/api';
import { IOtpResponse } from '@entities/fund';

import { ISejamConfirm, TSejamInfo } from './types';

export const getUserSejamInformation = () => {
  return ApiClientInstance.get<TSejamInfo>(`v2/profile/userinfo/sejam`);
};

export const sendSejamOtp = (): Promise<IOtpResponse> => {
  return ApiClientInstance.post<void, IOtpResponse>('v2/profile/userinfo/sejam/otp-request');
};

export const confirmSejamOtp = (data: ISejamConfirm): Promise<void> => {
  return ApiClientInstance.post<ISejamConfirm, void>('v2/profile/userinfo/sejam', data);
};
